export default function() {
	return {
		images: [],
		scrollProgress: 0, // 0 = position initiale, 1 = position finale (empilées)
		initialPosition: [],
		finalPosition: [],
		startOffset: [0,70,100,40], // Ajouté à l'écart initial calculé en fonction de la taille du container
		finalOffset: [0,30,55,15], // Écart final
		containerHeight: 0,
		isInView: false,
		observer: null,
		centerIndex: 1,

		init() {
			this.images = Array.from(this.$el.querySelectorAll('img'));
			if (this.images.length === 0) return;

			let loadedCount = 0;
			const totalImages = this.images.length;

			const initAfterLoad = () => {
				loadedCount++;
				if (loadedCount === totalImages) {
					this.initVars();
					this.setupIntersectionObserver();
					this.handleScroll();
				}
			};

			// Pour les images déjà chargées
			this.images.forEach(img => {
				if (img.complete) {
					initAfterLoad();
				} else {
					img.addEventListener('load', initAfterLoad);
				}
			});

			window.addEventListener('scroll', this.handleScroll.bind(this));

			this.$cleanup = () => {
				if (this.observer) {
					this.observer.disconnect();
				}
				window.removeEventListener('scroll', this.handleScroll.bind(this));
				this.images.forEach(img => {
					img.removeEventListener('load', initAfterLoad);
				});
			};
		},

		initVars() {
			this.containerHeight = this.$el.scrollHeight;

			let start_stack_height = 0;
			let final_stack_height = 0;
			this.images.forEach((img, index) => {
				start_stack_height += this.startOffset[index] / 100 * img.scrollHeight;
				final_stack_height += this.finalOffset[index] / 100 * img.scrollHeight;
				if (index === this.images.length - 1) {
					start_stack_height += img.scrollHeight;
					final_stack_height += img.scrollHeight;
				}
			});
			if (start_stack_height > this.containerHeight) {
				this.$el.style.height = start_stack_height + 'px';
			}

			const middle = this.containerHeight / 2;
			const global_offset_start = middle - start_stack_height / 2;
			const global_offset_final = middle - final_stack_height / 2;
			let total_start_offset = 0;
			let total_final_offset = 0;

			this.images.forEach((img, index) => {
				total_start_offset+= this.startOffset[index] / 100 * img.scrollHeight;
				total_final_offset+= this.finalOffset[index] / 100 * img.scrollHeight;

				this.initialPosition[index] = total_start_offset + global_offset_start;
				this.finalPosition[index] = total_final_offset + global_offset_final;

				img.style.top = Math.round(this.finalPosition[index]) + 'px';
				img.style.zIndex = this.images.length - index;

				// console.log('offset for ' + index + ' : ' +this.startOffset[index] / 100 * img.scrollHeight);
				// console.log(this.initialPosition[index], img.style.top);
				// console.log('--');
			});

			console.log(this.initialPosition[0]);
			console.log(this.finalPosition[0]);
		},

		setupIntersectionObserver() {
			this.observer = new IntersectionObserver((entries) => {

				this.isInView = entries[0].isIntersecting;
				if (this.isInView && !this.wasInView) {
					this.initVars();
				}
				this.wasInView = this.isInView;
				this.handleScroll();
			}, {
				root: null,
				rootMargin: '0px',
				threshold: 0.25
			});

			this.observer.observe(this.$el);
		},

		handleScroll() {
			if (!this.isInView) {
				return;
			}

			const container_rect = this.$el.getBoundingClientRect();
			const container_top = container_rect.top - 50;
			const windowHeight = window.innerHeight;
			const threshold = windowHeight * 0.20; // 75% de la hauteur de l'écran

			// Calculer la progression de 0 (début) à 1 (fin)
			if (container_top >= windowHeight) {
				this.scrollProgress = 0;
			} else if (container_top <= threshold) {
				this.scrollProgress = 1;
			} else {
				const totalTravel = windowHeight - threshold;
				const traveled = windowHeight - container_top;
				this.scrollProgress = Math.max(0, Math.min(1, traveled / totalTravel));
			}

			this.updateImagesPosition();
		},

		updateImagesPosition() {
			this.images.forEach((img, index) => {
				const initialPosition = this.initialPosition[index];
				const finalPosition = this.finalPosition[index];
				const currentPosition = initialPosition + (finalPosition - initialPosition) * this.scrollProgress;

				img.style.top = currentPosition + 'px';
			});
		}
	};
}
